<template>
  <div style="min-width: 240px;">
    <div v-for="(values, key) in parsed_content_by_key" :key="key">
      <p><b>{{key}}:</b></p>
      <div v-for="value in values" :key="value.key">
        <p>{{value.key}}: {{value.value}}</p>
      </div>
      <p v-if="key == 'statuses' && payload.statuses.awaiting_applicant == undefined" class="red_text">No awaiting_applicant offer for this position</p>
    </div>
    <alert-button :payload="payload.resource" :additional_data="{ resource_type: 'Position' }"></alert-button>
  </div>
</template>
<script>
import AlertButton from '@/components/AlertButton'
export default {
  name: 'position-offers-report',
  props: ['payload'],
  data () {
    return {
      parsed_content_by_key: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      let whitelist = ['statuses', 'rejected']
      for (let key in this.payload) {
        let unordered_values = this.payload[key]
        let ordered_values = []
        if (!whitelist.includes(key)) {
          continue
        }
        for (let value_key in unordered_values) {
          ordered_values.push({
            key: value_key,
            value: unordered_values[value_key]
          })
        }
        ordered_values.sort((a, b) => {
          return b.value - a.value
        })
        this.parsed_content_by_key[key] = ordered_values
      }
    }
  },
  components: {
    AlertButton
  }
}
</script>
